var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { diffComparisonValueFormat } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
var prevFromPct = function (current, diffPct) {
    if (diffPct === 0) {
        return current;
    }
    return Math.round(current / (1 + diffPct / 100));
};
var enrichTopChatterDiffs = function (row) { return (__assign(__assign({}, row), { prevMessagesSent: getPercentageDiff(prevFromPct(row.messagesSent, row.prevMessagesSent.diff), row.messagesSent), prevMessagesReceived: getPercentageDiff(prevFromPct(row.messagesReceived, row.prevMessagesReceived.diff), row.messagesReceived), prevAvgResponseTime: getPercentageDiff(prevFromPct(row.avgResponseTimeSeconds, row.prevAvgResponseTime.diff), row.avgResponseTimeSeconds, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }) })); };
var mockChatters = [
    {
        userId: 1,
        userName: 'Alex Morgan',
        department: 'Engineering',
        messagesSent: 169,
        messagesReceived: 40,
        avgResponseTime: '1h 28m',
        avgResponseTimeSeconds: 5280,
        prevMessagesSent: { diffString: '+12%', diff: 12 },
        prevMessagesReceived: { diffString: '+14%', diff: 14 },
        prevAvgResponseTime: { diffString: '+9%', diff: 9 }
    },
    {
        userId: 2,
        userName: 'Mia Chen',
        department: 'Support',
        messagesSent: 147,
        messagesReceived: 25,
        avgResponseTime: '2h 30m',
        avgResponseTimeSeconds: 9000,
        prevMessagesSent: { diffString: '+12%', diff: 12 },
        prevMessagesReceived: { diffString: '0%', diff: 0 },
        prevAvgResponseTime: { diffString: '+15%', diff: 15 }
    },
    {
        userId: 3,
        userName: 'Jordan Lee',
        department: 'Sales',
        messagesSent: 132,
        messagesReceived: 24,
        avgResponseTime: '31m',
        avgResponseTimeSeconds: 1860,
        prevMessagesSent: { diffString: '+12%', diff: 12 },
        prevMessagesReceived: { diffString: '0%', diff: 0 },
        prevAvgResponseTime: { diffString: '-21%', diff: -21 }
    },
    {
        userId: 4,
        userName: 'Noah Davis',
        department: 'Operations',
        messagesSent: 104,
        messagesReceived: 17,
        avgResponseTime: '2h 47m',
        avgResponseTimeSeconds: 10020,
        prevMessagesSent: { diffString: '+7%', diff: 7 },
        prevMessagesReceived: { diffString: '+6%', diff: 6 },
        prevAvgResponseTime: { diffString: '+17%', diff: 17 }
    },
    {
        userId: 5,
        userName: 'Sam Patel',
        department: 'Product',
        messagesSent: 97,
        messagesReceived: 26,
        avgResponseTime: '27m',
        avgResponseTimeSeconds: 1620,
        prevMessagesSent: { diffString: '-9%', diff: -9 },
        prevMessagesReceived: { diffString: '-10%', diff: -10 },
        prevAvgResponseTime: { diffString: '+13%', diff: 13 }
    },
    {
        userId: 6,
        userName: 'Priya Shah',
        department: 'Product',
        messagesSent: 88,
        messagesReceived: 22,
        avgResponseTime: '45m',
        avgResponseTimeSeconds: 2700,
        prevMessagesSent: { diffString: '+5%', diff: 5 },
        prevMessagesReceived: { diffString: '+3%', diff: 3 },
        prevAvgResponseTime: { diffString: '-8%', diff: -8 }
    },
    {
        userId: 7,
        userName: 'Casey Kim',
        department: 'Support',
        messagesSent: 76,
        messagesReceived: 19,
        avgResponseTime: '1h 12m',
        avgResponseTimeSeconds: 4320,
        prevMessagesSent: { diffString: '+4%', diff: 4 },
        prevMessagesReceived: { diffString: '+2%', diff: 2 },
        prevAvgResponseTime: { diffString: '+6%', diff: 6 }
    },
    {
        userId: 8,
        userName: 'Riley Chen',
        department: 'Marketing',
        messagesSent: 65,
        messagesReceived: 15,
        avgResponseTime: '52m',
        avgResponseTimeSeconds: 3120,
        prevMessagesSent: { diffString: '-3%', diff: -3 },
        prevMessagesReceived: { diffString: '+1%', diff: 1 },
        prevAvgResponseTime: { diffString: '-5%', diff: -5 }
    },
    {
        userId: 9,
        userName: 'Taylor Brooks',
        department: 'Support',
        messagesSent: 54,
        messagesReceived: 12,
        avgResponseTime: '1h 5m',
        avgResponseTimeSeconds: 3900,
        prevMessagesSent: { diffString: '+8%', diff: 8 },
        prevMessagesReceived: { diffString: '0%', diff: 0 },
        prevAvgResponseTime: { diffString: '+11%', diff: 11 }
    },
    {
        userId: 10,
        userName: 'Morgan Blake',
        department: 'Marketing',
        messagesSent: 48,
        messagesReceived: 11,
        avgResponseTime: '38m',
        avgResponseTimeSeconds: 2280,
        prevMessagesSent: { diffString: '-2%', diff: -2 },
        prevMessagesReceived: { diffString: '-4%', diff: -4 },
        prevAvgResponseTime: { diffString: '+4%', diff: 4 }
    },
    {
        userId: 11,
        userName: 'Sam Rivera',
        department: 'Sales',
        messagesSent: 42,
        messagesReceived: 9,
        avgResponseTime: '22m',
        avgResponseTimeSeconds: 1320,
        prevMessagesSent: { diffString: '+6%', diff: 6 },
        prevMessagesReceived: { diffString: '+5%', diff: 5 },
        prevAvgResponseTime: { diffString: '-12%', diff: -12 }
    },
    {
        userId: 12,
        userName: 'Taylor Kim',
        department: 'Marketing',
        messagesSent: 36,
        messagesReceived: 8,
        avgResponseTime: '1h 18m',
        avgResponseTimeSeconds: 4680,
        prevMessagesSent: { diffString: '+3%', diff: 3 },
        prevMessagesReceived: { diffString: '0%', diff: 0 },
        prevAvgResponseTime: { diffString: '+7%', diff: 7 }
    },
    {
        userId: 13,
        userName: 'Emma Wilson',
        department: 'Engineering',
        messagesSent: 31,
        messagesReceived: 7,
        avgResponseTime: '55m',
        avgResponseTimeSeconds: 3300,
        prevMessagesSent: { diffString: '-5%', diff: -5 },
        prevMessagesReceived: { diffString: '-3%', diff: -3 },
        prevAvgResponseTime: { diffString: '+2%', diff: 2 }
    },
    {
        userId: 14,
        userName: "Liam O'Connor",
        department: 'Operations',
        messagesSent: 27,
        messagesReceived: 6,
        avgResponseTime: '1h 42m',
        avgResponseTimeSeconds: 6120,
        prevMessagesSent: { diffString: '+1%', diff: 1 },
        prevMessagesReceived: { diffString: '+2%', diff: 2 },
        prevAvgResponseTime: { diffString: '+9%', diff: 9 }
    },
    {
        userId: 15,
        userName: 'Ava Nguyen',
        department: 'Product',
        messagesSent: 22,
        messagesReceived: 5,
        avgResponseTime: '33m',
        avgResponseTimeSeconds: 1980,
        prevMessagesSent: { diffString: '0%', diff: 0 },
        prevMessagesReceived: { diffString: '-1%', diff: -1 },
        prevAvgResponseTime: { diffString: '-6%', diff: -6 }
    }
];
export var topChatters = function (_input) { return mockChatters.map(enrichTopChatterDiffs); };
